var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetStartedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29688 2.84766L8.64844 2.49609H9.31641C9.24609 2.49609 9.63281 2.88281 9.63281 2.88281V8.61328L9.24609 8.92969H8.64844L8.29688 8.61328V2.84766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32018 4.11659C6.32018 4.11659 6.28671 4.45352 6.21963 4.55463C4.74497 5.49823 3.87352 7.04834 3.80651 9.00288C3.90706 11.901 6.21963 14.2263 9.06849 14.2263C11.9174 14.2263 14.23 11.901 14.1965 8.93552C14.23 7.11577 13.2581 5.49823 11.8839 4.55463C11.7833 4.35248 11.7163 4.15027 11.7163 4.15027L12.085 3.57736C12.085 3.57736 12.219 3.44257 12.4536 3.47625C14.2971 4.68942 15.5036 6.71133 15.5036 9.00288C15.5036 12.575 12.5878 15.4731 9.03502 15.4731C5.48227 15.4731 2.53287 12.575 2.56641 9.00295C2.56641 6.67772 3.80651 4.65574 5.58281 3.40889C5.78391 3.2741 5.985 3.64479 5.985 3.64479L6.32018 4.11659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartedIcon);
export default __webpack_public_path__ + "static/media/getStarted_icon.1dadb320f11613dabd0c11cacda7078e.svg";
export { ForwardRef as ReactComponent };